import { useTranslate } from "src/i18n";
import { pluralNumber } from "src/util/pluralNumber";

import { PluralForms } from "../../../../../utils";

export const useProductOffersTranslate = () => {
  const { t } = useTranslate();

  const offerForms: PluralForms = [
    t("product_offers.count_one", "предложение"),
    t("product_offers.count_few", "предложения"),
    t("product_offers.count_many", "предложений"),
  ];

  const deliveryDays: PluralForms = [
    t("product_info.delivery_day_one", "день"),
    t("product_info.delivery_day_few", "дня"),
    t("product_info.delivery_day_many", "дней"),
  ];

  const deliveryHours: PluralForms = [
    t("product_info.delivery_hour_one", "час"),
    t("product_info.delivery_hour_few", "часа"),
    t("product_info.delivery_hour_many", "часов"),
  ];

  return {
    offers_count: (count: number) =>
      `${count} ${pluralNumber(count, offerForms)}`,
    open_offer: t("product_offers.open", "Открыть на площадке"),
    unknown_seller: t("product_offers.unknown_seller", "Продавец не указан"),
    delivery_days: deliveryDays,
    delivery_hours: deliveryHours,
  };
};
